/**
 * 公司信息
 */

import request from '@/utils/request'

/**
 * 分页公司
 * @param data
 */
export function companySelect(data) {
  return request({
    url: '/company/select',
    method: 'post',
    data
  })
}

/**
 * 新增公司
 * @param data
 */
export function companySave(data) {
  return request({
    url: '/company/save',
    method: 'post',
    data
  })
}

/**
 * 修改公司
 * @param data
 */
export function companyUpdate(data) {
  return request({
    url: '/company/update',
    method: 'post',
    data
  })
}

/**
 * 公司详情
 * @param data
 */
export function companyDetails(data) {
  return request({
    url: '/company/select/details',
    method: 'post',
    data
  })
}

/**
 * 分页公司流程
 * @param data
 */
export function companySelectProcess(data) {
  return request({
    url: '/company/select/process',
    method: 'post',
    data
  })
}
/**
 * 分页公司流程(公司信息更新页面使用)
 * @param data
 */
export function companySelectApprovalProcess(data) {
  return request({
    url: '/company/select/latest/process',
    method: 'post',
    data
  })
}
/**
 * 导入公司
 * @param file
 */
export function patentImport(file) {
  const formData = new FormData()
  formData.append('file', file)
  return request({
    url: '/company/import',
    method: 'post',
    data: formData
  })
}

/**
* 修改公司流程
* @param data
*/
export function companyUpdateProcess(data) {
  return request({
    url: '/company/update/process',
    method: 'post',
    data
  })
}

/**
* 公司流程详情
* @param id
* @param companyId
*/
export function companyProcessDetails(id, companyId) {
  return request({
    url: '/company/process/details',
    method: 'post',
    data: { id: id, companyId: companyId }
  })
}

/**
* 公司流程详情
* @param id
*/
export function companyList(data) {
  return request({
    url: '/company/select',
    method: 'post',
    data
  })
}

/**
* 公司流程详情
* @param id
*/
export function companyEnableDisable(data) {
  return request({
    url: '/company/update/enable/disable',
    method: 'post',
    data
  })
}

/**
* 公司流程详情
* @param id
*/
export function companyDelete(data) {
  return request({
    url: '/company/delete',
    method: 'post',
    data
  })
}
